import { create } from "zustand";

/**
 * Global "Ben / Herkes" (Me / Everyone) toggle. Persisted in localStorage so
 * the choice survives page reloads. When `scope === "me"`, the sidebar,
 * project grid, project detail chip counts, and task lists all narrow to
 * the current user.
 */
const KEY = "taskora_view_scope";

const initial = () => {
  try {
    const v = localStorage.getItem(KEY);
    return v === "me" ? "me" : "everyone";
  } catch {
    return "everyone";
  }
};

export const useViewScopeStore = create((set) => ({
  scope: initial(), // "me" | "everyone"
  setScope(next) {
    const s = next === "me" ? "me" : "everyone";
    try {
      localStorage.setItem(KEY, s);
    } catch {
      /* ignore */
    }
    set({ scope: s });
  },
  toggle() {
    set((state) => {
      const s = state.scope === "me" ? "everyone" : "me";
      try {
        localStorage.setItem(KEY, s);
      } catch {
        /* ignore */
      }
      return { scope: s };
    });
  },
}));
